/**
 * Định dạng số/thời gian cho UI — Prompt.md §24, §26, §27.
 *
 * Nằm ở tầng app: `packages/*` không được biết locale nào đang hiển thị (§4), và `Intl` với
 * `Date` chỉ được dùng ở ranh giới này.
 */

const dayFormatter = new Intl.DateTimeFormat("vi-VN", {
  weekday: "short",
  day: "2-digit",
  month: "2-digit",
});

const timeFormatter = new Intl.DateTimeFormat("vi-VN", { hour: "2-digit", minute: "2-digit" });

/** `mm:ss`, hoặc `h:mm:ss` khi vượt một giờ. Dùng cho đồng hồ đang chạy (§24). */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const seconds = String(total % 60).padStart(2, "0");
  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${String(minutes).padStart(2, "0")}:${seconds}`;
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, "0")}:${seconds}`;
}

/** §26 hiển thị thời lượng theo **phút**, không theo giây. */
export function formatMinutes(ms: number): string {
  return `${Math.round(ms / 60_000)} phút`;
}

export function formatDay(timestamp: number): string {
  return dayFormatter.format(new Date(timestamp));
}

export function formatTime(timestamp: number): string {
  return timeFormatter.format(new Date(timestamp));
}
